import React from 'react'
import classes from '../css/TimeOutPage.module.css'
import { Link, useNavigate } from 'react-router-dom'


const TimeOutPage = () => {

        const navigate = useNavigate()
    
  return (
     <div className={`cptpl_page ${classes.wrapper}`}>
   <input type="hidden" value="20221206" name="cptpl_template" class="cptpl_template"/>
  <div className={classes.card}>
    <div className={classes.logoHeading}>
      <img src="https://vd-kickwin.gameit.in/assets/images/soccer-ball.png" alt="Logo" className={`cptpl_logo cptpl_logo_static  ${classes.logo}`}
     crossorigin="anonymous" />
      <h3 className={`cptpl_service ${classes.heading}`}>Kick n Winn</h3>
    </div>

    <div className={classes.block_content} >

    {/* <h1 className={classes.err_text}>ERROR</h1> */}

    <p className={classes.subtext}>
    A system error occurred and we could not complete the transaction.
    </p>

      <div className={classes.btns}>
        {/* <button type="submit" className={`protected cptpl_subscribe ${classes.subbutton}`}>
        ACCEPT
      </button> */}
      <button type="button" className={`protected cptpl_exit  ${classes.extbutton}`} onClick={()=>navigate('/subscribe')}>
        RETRY
      </button>
      </div>
      </div>

    
  </div>
</div>
  )
}

export default TimeOutPage
